
























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import {
	SaveLojaUseCase,
	FindLojaUseCase,
	DeleteLojaUseCase,
	ComandaUseCase,
} from '@/usecases'
import {
	Loja,
	Usuario,
	FormLoja,
	FormPontoDeVenda,
	Marca,
	Cliente,
	ComandaForm,
	Comanda,
	ConfiguracaoDeNotificacaoPorUsuario,
	ConfiguracaoDeNotificacaoPorEmail,
	AvaliacaoNpsConfigLoja,
	TipoAvaliacaoNps,
} from '@/models'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import WrapperDeUpload from '@/components/ui/WrapperDeUpload.vue'
import CampoDeCnpj from '@/components/ui/CampoDeCnpj.vue'
import CampoDeCep from '@/components/ui/CampoDeCep.vue'
import CampoDeTelefone from '@/components/ui/CampoDeTelefone.vue'
import CamposDeEndereco from '@/components/ui/CamposDeEndereco.vue'
import EdicaoGenerica from '@/components/layout/EdicaoGenerica.vue'
import DialogoDePontoDeVenda from '@/components/loja/DialogoDePontoDeVenda.vue'
import CardDeAcoesDoPdv from '@/components/loja/CardDeAcoesDoPdv.vue'
import ConfirmExclusionDialog from '@/components/ui/ConfirmExclusionDialog.vue'
import SeletorDeCfop from '@/components/fiscal/SeletorDeCfop.vue'
import SeletorDeRegimeFiscal from '@/components/fiscal/SeletorDeRegimeFiscal.vue'
import AvatarDeUsuario from '@/components/usuario/AvatarDeUsuario.vue'
import DialogoDeBuscaDeUsuario from '@/components/usuario/DialogoDeBuscaDeUsuario.vue'
import TableDeTiposDePagamento from '@/components/loja/TableDeTiposDePagamento.vue'
import TableDeSeriesFiscais from '@/components/loja/TableDeSeriesFiscais.vue'
import { maiorOuIgualAZero, obrigatorio, maiorOuIgualAUm } from '@/shareds/regras-de-form'
import { UsuariosModule } from '@/store/vuex/usuario/UsuariosStore'
import RevealPasswordField from '@/components/ui/RevealPasswordField.vue'
import TabDeTabelaDePreco from './TabDeTabelaDePreco.vue'
import {
	criarLoja,
	tipoDePagamentoTemRecorrencia,
	usuarioParaOperador,
	montarPoliticaDeTrocaPadrao,
	PLACEHOLDER_DIAS_DEVOLUCAO,
	substituirDiasDeDevolucao,
} from '@/shareds/loja-shareds'
import AppStore from '@/store/vuex/aplicacao/AppStore'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import ListaDeEstacoesDeImpressao from '@/components/loja/ListaDeEstacoesDeImpressao.vue'
import DialogoDeImportacaoDeOutrasLojas, {
	CamposDaImportacao,
} from './DialogoDeImportacaoDeOutrasLojas.vue'
import {
	formatarCnpjOuCpf,
	removerCaracteresEspeciaisDeTexto,
} from '@/shareds/formatadores'
import { nextTick } from '@/shareds/utils'
import SeletorDeGruposEconomicos from '@/components/loja/SeletorDeGruposEconomicos.vue'
import ListagemDeMarcasPorLoja from './ListagemDeMarcasPorLoja.vue'
import ListagemDeLojasPorLoja from './ListagemDeLojasPorLoja.vue'
import TabDeEnvioDeEmail from './TabDeEnvioDeEmail.vue'
import { DataOptions } from 'vuetify'
import ListagemDeClientesPorLoja from '@/components/cliente/ListagemDeClientesPorLoja.vue'
import DialogoDeCadastroDeComandas from '../DialogoDeCadastroDeComandas.vue'
import CardDeAcoesDaComanda from '@/components/loja/CardDeAcoesDaComanda.vue'
import ListaDeNotificacoesPorConfigPorEmail from '@/components/usuario/ListaDeNotificacoesPorConfigPorEmail.vue'
import ListaDeNotificacoesPorConfigPorUsuario from '@/components/usuario/ListaDeNotificacoesPorConfigPorUsuario.vue'
import SeletorDeTabelaDePreco from '@/components/tabeladepreco/SeletorDeTabelaDePreco.vue'
import { downloadFilesFromS3 } from '@/shareds/s3/files'
@Component({
	components: {
		WrapperDeUpload,
		CampoDeCnpj,
		CampoDeCep,
		CampoDeTelefone,
		CamposDeEndereco,
		EdicaoGenerica,
		DialogoDePontoDeVenda,
		CardDeAcoesDoPdv,
		ConfirmExclusionDialog,
		SeletorDeCfop,
		SeletorDeRegimeFiscal,
		AvatarDeUsuario,
		TableDeTiposDePagamento,
		DialogoDeBuscaDeUsuario,
		TableDeSeriesFiscais,
		RevealPasswordField,
		TabDeTabelaDePreco,
		DialogoDeImportacaoDeOutrasLojas,
		SeletorDeGruposEconomicos,
		ListagemDeMarcasPorLoja,
		ListagemDeClientesPorLoja,
		DialogoDeCadastroDeComandas,
		CardDeAcoesDaComanda,
		ListagemDeLojasPorLoja,
		TabDeEnvioDeEmail,
		ListaDeNotificacoesPorConfigPorUsuario,
		ListaDeNotificacoesPorConfigPorEmail,
		SeletorDeTabelaDePreco,
		ListaDeEstacoesDeImpressao,
	},
})
export default class EdicaoDeLoja extends Vue {
	@Ref() edicaoGenerica!: EdicaoGenerica<Loja>
	@Ref() tabDeEnvioDeEmail?: TabDeEnvioDeEmail
	@Ref() form0!: HTMLFormElement
	@Ref() form1!: HTMLFormElement
	@Ref() form2!: HTMLFormElement
	@Ref() form3!: HTMLFormElement
	@Ref() form4!: HTMLFormElement
	@Ref() form5!: HTMLFormElement
	@Ref() form6!: HTMLFormElement
	@Ref() form7!: HTMLFormElement
	@Ref() camposDeTelefones!: CampoDeTelefone[]
	@Ref() dialogo!: DialogoDeImportacaoDeOutrasLojas
	@Prop({ type: Boolean }) novo!: boolean
	@Prop({ type: String, default: '' }) id!: string

	AlertModule = AlertModule
	removerCaracteresEspeciaisDeTexto = removerCaracteresEspeciaisDeTexto
	maiorOuIgualAZero = maiorOuIgualAZero
	maiorOuIgualAUm = maiorOuIgualAUm

	semPlaceholderDeDiasDeDevolucao = (texto: string | null) => {
		const diasParaDevolucao = this.loja?.configuracaoDaLoja.diasParaDevolucao ?? null
		const textoFinal = substituirDiasDeDevolucao(texto ?? '', diasParaDevolucao)
		return (
			!textoFinal.includes(PLACEHOLDER_DIAS_DEVOLUCAO) ||
			`Substitua ${PLACEHOLDER_DIAS_DEVOLUCAO} pelo prazo de devolução em dias ou configure na loja o parâmetro "Dias para devolução"`
		)
	}

	politicaDeTrocaObrigatoria = (texto: string | null) =>
		!!texto?.trim() || 'Informe o texto da política de troca'

	clientes: Cliente[] = []
	loja: FormLoja | null = null
	versaoAnterior: FormLoja | null = null
	carregando = false
	salvando = false
	excluindo = false
	trabalharComRomaneio = false
	appStore = AppStore
	totalDeRegistros = -1
	configuracoesDeNotificacaoPorUsuario: ConfiguracaoDeNotificacaoPorUsuario[] = []
	configuracoesDeNotificacaoPorEmail: ConfiguracaoDeNotificacaoPorEmail[] = []
	wppFormatado = ''
	avaliacaoNpsConfigLocal: AvaliacaoNpsConfigLoja[] = []
	lojasDoGrupoEconomico: Loja[] = []
	carregandoLojasDoGrupoEconomico = false

	headers = [
		{ text: 'Nome', value: 'razaoSocialOuNome' },
		{ text: 'Cpf/Cnpj', value: 'cnpjOuCpf' },
		{ text: 'Ações', value: 'actions', sortable: false, align: 'center' },
	]

	tipoDeCodigo = ['Sku', 'Ean']

	buscaPorNomeEIdenticador = ''
	comandasSelecionadas: ComandaForm[] | null = null
	tabs = [
		'Geral',
		'Endereço e Contato',
		'Fiscal',
		'Pagamentos',
		'Tabelas de Preços',
		'Marcas',
		'Clientes',
		'Lojas',
		'Envio de e-mail',
		'Notificações',
		'Avaliação NPS',
		'Romaneios',
		'Outros',
	]

	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	pdvSelecionado = ''
	aba = null
	abaEmail = null
	baixandoCertificado = false

	get clientesLoja() {
		return this.loja?.clientes
	}

	selecionarModuloDaAba(chave: string) {
		switch(chave) {
			case 'aba-1': 
				return 'Estoque'
			case 'aba-2': 
				return 'Vendas'
			case 'aba-3': 
				return 'Nota em Transito'
			default:
				return 'Estoque'
		}
	}

	@Watch('loja')
	changeTabs() {
		const configTrabalharComRomaneio: boolean =
			this.loja?.configuracaoDaLoja?.trabalharComRomaneio ?? false

		this.trabalharComRomaneio = configTrabalharComRomaneio

		this.tabs = [
			'Geral',
			'Endereço e Contato',
			'Fiscal',
			'Pagamentos',
			'Tabelas de Preços',
			'Marcas',
			'Clientes',
			'Lojas',
			'Envio de e-mail',
			'Notificações',
			'Avaliação NPS',
			...(this.podeEditarEstacaoDeImpressora ? ['Estações de Impressão'] : []),
			...(configTrabalharComRomaneio ? ['Romaneios'] : []),
			'Outros',
		]
	}

	get podeEditarEstacaoDeImpressora() {
		return !!UserLoginStore.permiteRegraDeNegocio('permite-editar-estacao-de-impressora')
	}

	// Os refs dos formulários precisam ser 'form0'..'form{tabs.length - 1}' sem furo, porque
	// validarFormularios itera por índice. Derivar da própria lista de abas é o que mantém isso
	// verdadeiro quando uma aba opcional entra ou sai.
	get indiceDaAbaDeEstacoesDeImpressao() {
		return this.tabs.indexOf('Estações de Impressão')
	}

	get indiceDaAbaDeRomaneios() {
		return this.tabs.indexOf('Romaneios')
	}

	get indiceDaAbaDeOutros() {
		return this.tabs.indexOf('Outros')
	}

	get pontosDeVendaDisponiveis(): FormPontoDeVenda[] {
		return this.loja?.pdvs ? this.loja.pdvs : []
	}

	get tab() {
		if (!this.$route.query.t) return 0
		const index = this.tabs.findIndex(tab => tab === this.$route.query.t)
		return index !== -1 ? index : null
	}

	set tab(value: number | null) {
		const tab = typeof value === 'number' ? this.tabs[value] : undefined
		this.$router
			.push({
				name: this.$route.name as string,
				query: { t: !value ? undefined : tab },
			})
			.catch()
	}
	erro: null | Error = null

	saveUseCase = new SaveLojaUseCase()
	findUseCase = new FindLojaUseCase()
	deleteUseCase = new DeleteLojaUseCase()
	comandaUseCase = new ComandaUseCase()

	$refs!: {
		[key: string]: HTMLFormElement
	}

	obrigatorio = obrigatorio

	inserirComanda(comanda: Comanda) {
		if (!this.loja) return
		if (this.loja.comandas === null) this.loja.comandas = []

		this.loja.comandas.push(comanda)
	}

	@Watch('id', { immediate: true })
	onChangeId() {
		this.carregar()
	}

	@Watch('loja.grupoEconomico.id', { immediate: true })
	async carregarLojasDoGrupoEconomico() {
		const grupoEconomicoId = this.loja?.grupoEconomico?.id
		if (!grupoEconomicoId) {
			this.lojasDoGrupoEconomico = []
			return
		}
		try {
			this.carregandoLojasDoGrupoEconomico = true
			const pagina = await this.findUseCase.findLojasByGrupoEconomicoId(grupoEconomicoId, {
				params: { size: 200 },
			})
			this.lojasDoGrupoEconomico = pagina.content.filter(({ id }) => id !== this.loja?.id)
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.carregandoLojasDoGrupoEconomico = false
		}
	}

	get razaoSocialSemCaracteresEspeciais() {
		return this.loja
			? removerCaracteresEspeciaisDeTexto(this.loja.razaoSocial)
			: ''
	}

	get nomeDoArquivoCertNfe() {
		if (!this.loja || !this.loja.cnpj) return 'Loja deve ter um cnpj'
		if (!this.loja.urlCertificadoNfe) return 'Nenhum certificado selecionado...'

		return decodeURI(this.loja.urlCertificadoNfe.split('/').pop() as string)
	}

	get pdvsOrdenados() {
		return this.loja
			? [...this.loja.pdvs].sort((pdvA, pdvB) =>
				pdvA.nome.localeCompare(pdvB.nome),
			)
			: []
	}

	get comandasOrdenados() {
		const comandas =
			this.loja && this.loja.comandas && this.comandasSelecionadas === null
				? [...this.loja.comandas].sort((comandaA, comandaB) =>
					comandaA.nome.localeCompare(comandaB.nome),
				)
				: this.comandasSelecionadas != null &&
				this.comandasSelecionadas.length > 0
					? [...this.comandasSelecionadas].sort((comandaA, comandaB) =>
						comandaA.nome.localeCompare(comandaB.nome),
					)
					: []

		return comandas
	}

	get podeEditar() {
		return this.edicaoGenerica.podeEditar
	}

	get temAcessoIrrestrito() {
		return UserLoginStore.permiteRegraDeNegocio('acesso-irrestrito')
	}

	deletarMarcaDaLoja(marca: Marca) {
		const idx = this.loja?.marcas.findIndex(
			marcaLoja => marcaLoja.id === marca.id,
		)
		if (idx != undefined) this.loja?.marcas.splice(idx, 1)
	}

	updateListaDeMarca(marcasUpdate: Marca[]) {
		marcasUpdate.forEach(marca => {
			this.loja?.marcas.push(marca)
		})
	}

	@Watch('buscaPorNomeEIdenticador', { immediate: true })
	async bucarComanda() {
		if (!this.loja) return
		if (!this.buscaPorNomeEIdenticador) {
			this.comandasSelecionadas = null
			return
		}
		try {
			const comanda = await this.comandaUseCase.getComandas(
				this.buscaPorNomeEIdenticador,
				this.loja.id,
			)
			this.comandasSelecionadas = comanda.content
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	async carregar() {
		try {
			this.carregando = true
			this.loja = this.novo
				? criarLoja()
				: await this.findUseCase.findLojaById(this.id)

			if(this.loja.id.length > 0) {
				this.configuracoesDeNotificacaoPorUsuario = await this.findUseCase.findConfigDeNotificacaoPorUsuario(this.id)
				this.configuracoesDeNotificacaoPorEmail = await this.findUseCase.findConfigDeNotificacaoPorEmail(this.id)
			}

			this.avaliacaoNpsConfigLocal = this.loja.avaliacaoNpsConfig
				? [...this.loja.avaliacaoNpsConfig].sort(
					(a, b) => (a.ordem || 0) - (b.ordem || 0),
				)
				: []
				
			nextTick().then(() => {
				this.versaoAnterior = JSON.parse(JSON.stringify(this.loja))
			})
		} catch (error: any) {
			this.erro = error
			AlertModule.setError(error)
		} finally {
			this.$nextTick(() => {
				this.carregando = false
			})
		}
	}

	async abrirDialogo() {
		this.dialogo.mostrar()
	}

	redirecionarAba(campos: CamposDaImportacao[]) {
		if (campos.includes('pagamentos')) {
			this.tab = this.tabs.indexOf('Pagamentos')
			return
		}
	}

	validarFormularios() {
		for (let i = 0; i < this.tabs.length; ++i) {
			if (this.$refs[`form${i}`].validate()) continue
			this.tab = i
			return false
		}
		return true
	}

	@Watch('pdvSelecionado')
	onChangePdvSelecionado() {
		if (this.loja != undefined) {
			const pdvEncontrado = this.loja.pdvs.find(
				pdv => pdv.nome === this.pdvSelecionado,
			)

			if (pdvEncontrado != undefined) {
				this.loja.configuracaoDaLoja.pdvIntegracao = pdvEncontrado.id
			}
		}
	}

	get pdvSelecionadoFormatado() {
		if (!this.loja) return 'TESTE'

		const lojaAtual = this.loja

		const pdvFiltrado = this.pontosDeVendaDisponiveis.find(
			pdv => pdv.id === lojaAtual.configuracaoDaLoja.pdvIntegracao,
		)

		return pdvFiltrado ? pdvFiltrado.nome : ''
	}

	set pdvSelecionadoFormatado(nomePdv: string) {
		this.pdvSelecionado = nomePdv
	}

	async salvar(): Promise<boolean> {
		if (!this.loja) return false
		if (!this.validarFormularios()) return false
		if (!this.loja.telefones || this.loja.telefones.length === 0) {
			this.tab = 1
			AlertModule.setError('Informe ao menos um telefone')
			return false
		}

		if (this.loja.grupoEconomico && this.loja.grupoEconomico.id === '') {
			this.tab = 0
			AlertModule.setError('Informe um grupo econômico')
			return false
		}

		if (!this.validarOrdemNps()) {
			return false
		}

		if (this.loja.configuracaoDaLoja.sintaxeBoxlink !== '' && this.loja.configuracaoDaLoja.sintaxeBoxlink !== null){
			if (this.loja.configuracaoDaLoja.tamanhoEtiquetaBoxlink === null || this.loja.configuracaoDaLoja.tamanhoEtiquetaBoxlink === '') { AlertModule.setError("Configure um tamanho para a etiqueta BoxLink"); return false }
			if (this.loja.configuracaoDaLoja.tokenBoxlink === null || this.loja.configuracaoDaLoja.tokenBoxlink === '') { AlertModule.setError("Configure o token para a etiqueta BoxLink"); return false }
		}
		
		try {
			this.salvando = true
			this.loja.avaliacaoNpsConfig = [...this.avaliacaoNpsConfigLocal]
			
			const lojaSalva = await this.saveUseCase.save({
				...this.loja,
				razaoSocial: this.razaoSocialSemCaracteresEspeciais,
				tiposDePagamento: this.loja.tiposDePagamento.map(tipoDePagamento =>
					tipoDePagamentoTemRecorrencia(tipoDePagamento)
						? tipoDePagamento
						: { ...tipoDePagamento, diasDeRecorrencia: 0 },
				),
				configuracaoDaLoja: {
					...this.loja.configuracaoDaLoja,
					codigoCSRT: this.loja.configuracaoDaLoja.codigoCSRT?.trim() || null,
					politicaDeTrocaTexto: this.politicaDeTrocaParaSalvar(),
				},
			})

			this.loja = lojaSalva
			try {
				await this.tabDeEnvioDeEmail?.salvar()
			} catch (error: any) {
				this.tab = this.tabs.indexOf('Envio de e-mail')
				AlertModule.setError(error)
				return false
			}
			AlertModule.setSuccess('Loja salva com sucesso')
			await nextTick()
			this.versaoAnterior = JSON.parse(
				JSON.stringify({
					...this.loja,
					cnpj: formatarCnpjOuCpf(this.loja.cnpj),
				}),
			)
			if (!this.novo) return true
			this.$router.push({
				name: 'Loja',
				params: { id: lojaSalva.id },
			})
			return true
		} catch (error: any) {
			AlertModule.setError(error)
			return false
		} finally {
			this.salvando = false
			await this.carregar() 
		}
	}

	adicionarTelefone() {
		if (!this.loja) return
		this.loja.telefones.push('')
		this.$nextTick(() => {
			if (!this.loja) return
			const campo = this.camposDeTelefones[this.loja.telefones.length - 1]
			campo.$children[0].focus()
		})
	}

	inserirFuncionario(usuario: Usuario) {
		if (!this.loja) return
		const jaEstaNaLoja = this.loja.usuarios.some(({ id }) => usuario.id === id)
		if (jaEstaNaLoja) {
			AlertModule.setError(
				`${usuario.nome} já consta no quadro de funcionários`,
			)
			return
		}
		this.loja.usuarios.push(usuarioParaOperador(usuario))
	}

	async excluirLoja() {
		try {
			this.excluindo = true
			await this.deleteUseCase.delete(this.id)
			await this.$router.push({ name: 'Lojas' })
		} catch (error: any) {
			AlertModule.setError(error)
		} finally {
			this.excluindo = false
		}
	}

	displayPerfilTooltip(id: string) {
		const perfil = UsuariosModule.perfil(id)
		return perfil ? `${perfil.nome} - ` : ''
	}

	removerUsuarioDaLoja(id: string) {
		if (!this.loja) return
		this.loja.usuarios = this.loja.usuarios.filter(usuario => usuario.id !== id)
	}

	get folderName() {
		if (!this.loja?.cnpj) return ''

		const cnpj = this.loja?.cnpj.replace(/[^A-Za-z0-9]/g, '').toUpperCase()
		return `certificado-nfe/${cnpj}`
	}

	get temCnpj() {
		return !!this.loja?.cnpj
	}

	get nomeFantasiaSize() {
		return this.loja?.identificador ? 10 : 12
	}

	async beforeRouteLeave(to, from, next) {
		next(!(await this.edicaoGenerica.validarTransicao()))
	}

	onInputWhatsApp(valor) {
		if(!this.loja) return

		const numeros = valor.replace(/\D/g, '').substring(0, 11)
		let formatado = ''

		if (numeros.length > 0) {
			formatado += '(' + numeros.slice(0, 2)
		}
		if (numeros.length >= 3) {
			formatado += ') ' + numeros.slice(2, 7)
		}
		if (numeros.length >= 8) {
			formatado += '-' + numeros.slice(7, 11)
		}

		this.wppFormatado = formatado
		this.loja.configuracaoDaLoja.wppEnvioFechamento = formatado
	}

	async baixarCertificadoNfe() {
		if (!this.loja || !this.loja.urlCertificadoNfe) return AlertModule.setError("Não possui certificado configurado para download.")
		const urlCertificadoNfe = this.loja.urlCertificadoNfe

		try {
			this.baixandoCertificado = true
			const caminhoDaPasta = this.extrairCaminho(urlCertificadoNfe)
			const nomeDoArquivo = this.extrairNomeDosDocumentos(urlCertificadoNfe)
			// caminhoDaPastaAbsoluto=true pois extrairCaminho já inclui o subdomínio no caminho
			await downloadFilesFromS3(`${caminhoDaPasta}`, nomeDoArquivo, true)
		} catch (error: any) {
			AlertModule.setError('Houve um problema ao baixar o arquivo')
		} finally {
			this.baixandoCertificado = false
		}
	}

	extrairCaminho(url: string) {
		return url.replace(/.*\/([^/]+\/[^/]+\/[^/]+)\/[^/]+$/, "$1");
	}

	extrairNomeDosDocumentos(url: string) {
		const lastSlashIndex = url.lastIndexOf("/")
		const fileName = url.substring(lastSlashIndex + 1)
		return fileName
	}

	tiposAvaliacaoNps: { value: TipoAvaliacaoNps; label: string }[] = [
		{ value: 'Geral',                label: 'NPS geral' },
		{ value: 'Atendimento',          label: 'Atendimento' },
		{ value: 'Produtos',             label: 'Produtos' },
		{ value: 'Preços e condições',   label: 'Preços e condições' },
		{ value: 'Entrega e retirada',   label: 'Entrega e retirada' },
		{ value: 'Motivo',               label: 'Motivo da nota' },
		{ value: 'Sugestão de melhoria', label: 'Sugestão de melhoria' },
	]

	adicionarConfigNps() {
		if (!this.loja) return

		const proximaOrdem = this.avaliacaoNpsConfigLocal.length + 1

		this.avaliacaoNpsConfigLocal.push({
			id: '',
			tipo: 'Geral',
			pergunta:
      'Quão provável é que você recomende nossa loja a um amigo ou familiar?',
			lojaId: this.loja.id,
			ativo: true,
			ordem: proximaOrdem,
			obrigatoria: false,
		})
	}

	removerConfigNps(index: number) {
		this.avaliacaoNpsConfigLocal.splice(index, 1)

		this.avaliacaoNpsConfigLocal.forEach((config, idx) => {
			config.ordem = idx + 1
		})
	}

	onChangeTipoPergunta(config: AvaliacaoNpsConfigLoja) {
		switch (config.tipo) {
			case 'Geral':
				config.pergunta =
        'Quão provável é que você recomende nossa loja a um amigo ou familiar?'
				break
			case 'Atendimento':
				config.pergunta = 'Como você avalia o atendimento recebido?'
				break
			case 'Produtos':
				config.pergunta = 'Como você avalia os produtos adquiridos?'
				break
			case 'Preços e condições':
				config.pergunta =
        'Como você avalia os preços e condições de pagamento?'
				break
			case 'Entrega e retirada':
				config.pergunta =
        'Como você avalia o processo de entrega ou retirada?'
				break
			case 'Motivo':
				config.pergunta = 'Conte-nos o motivo da sua nota.'
				break
			case 'Sugestão de melhoria':
				config.pergunta = 'Deixe aqui suas sugestões de melhoria.'
				break
		}
	}

	validarOrdemNps(): boolean {
		if (!this.loja?.configuracaoDaLoja?.utilizarAvaliacaoNps) {
			return true
		}

		if (!this.avaliacaoNpsConfigLocal.length) {
			return true
		}

		const ordens = this.avaliacaoNpsConfigLocal.map(c => c.ordem)

		if (ordens.some(o => !o || o <= 0)) {
			this.tab = this.tabs.indexOf('Avaliação NPS')
			AlertModule.setError(
				'Todas as perguntas de NPS devem ter uma ordem maior ou igual a 1.',
			)
			return false
		}

		const setOrdens = new Set(ordens)
		if (setOrdens.size !== ordens.length) {
			this.tab = this.tabs.indexOf('Avaliação NPS')
			AlertModule.setError(
				'A ordem das perguntas de NPS não pode ter números repetidos.',
			)
			return false
		}

		const ordensOrdenadas = [...ordens].sort((a, b) => a - b)
		for (let i = 0; i < ordensOrdenadas.length; i++) {
			const esperado = i + 1
			if (ordensOrdenadas[i] !== esperado) {
				this.tab = this.tabs.indexOf('Avaliação NPS')
				AlertModule.setError(
					'A ordem das perguntas de NPS deve ser uma sequência contínua a partir de 1 (ex.: 1, 2, 3).',
				)
				return false
			}
		}

		return true
	}

	tiposDePreVendaBase = [
		{ text: 'Venda', value: 'venda' },
		{ text: 'Demonstração', value: 'demonstracao' },
		{ text: 'Consignação', value: 'consignacao' },
		{ text: 'Brinde', value: 'brinde' },
		{ text: 'Outras saídas', value: 'outras saidas' },
		{ text: 'Conserto', value: 'conserto' },
		{ text: 'Ativo', value: 'ativo' },
		{ text: 'Devolução saída', value: 'devolucao saida' },
		{ text: 'Atacado', value: 'atacado'},
		{ text: 'Transferência', value: 'transferencia' },
	]

	get dicaDaPoliticaDeTroca() {
		const texto = this.loja?.configuracaoDaLoja.politicaDeTrocaTexto ?? ''
		if (texto.includes(PLACEHOLDER_DIAS_DEVOLUCAO)) {
			return `Substitua ${PLACEHOLDER_DIAS_DEVOLUCAO} pelo prazo de devolução em dias antes de salvar.`
		}
		return 'Impresso no cupom da NFC-e como digitado, preservando as quebras de linha. Alterar os dias para devolução depois não atualiza este texto.'
	}

	politicaDeTrocaParaSalvar(): string | null {
		if (!this.loja) return null
		const { politicaDeTrocaTexto, diasParaDevolucao } = this.loja.configuracaoDaLoja
		if (!politicaDeTrocaTexto) return politicaDeTrocaTexto
		return substituirDiasDeDevolucao(politicaDeTrocaTexto, diasParaDevolucao)
	}

	aoDigitarPoliticaDeTroca(texto: string) {
		if (!this.loja) return
		const configuracao = this.loja.configuracaoDaLoja
		configuracao.politicaDeTrocaTexto = substituirDiasDeDevolucao(
			texto,
			configuracao.diasParaDevolucao,
		)
	}

	preencherPoliticaDeTrocaPadrao(habilitada: boolean | null) {
		if (!habilitada || !this.loja) return
		const configuracao = this.loja.configuracaoDaLoja
		if (configuracao.politicaDeTrocaTexto?.trim()) return
		configuracao.politicaDeTrocaTexto = montarPoliticaDeTrocaPadrao(
			configuracao.diasParaDevolucao,
		)
	}
}
